import React from 'react';
import styled from 'styled-components';

const CheckboxContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 10px 0;
    cursor: pointer;
`;

const CheckboxField = styled.input`
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 1px solid #ddd;
    margin-right: 10px;
    cursor: pointer;
    :focus{
        outline: none;
        border: 1px solid #64A6BD;
    }
`;

const Label = styled.label`
    cursor: pointer;
    margin-bottom: 0 !important;
`;

const Checkbox = ({disabled, label, value, onChange, required}) => (
    <CheckboxContainer>
        <CheckboxField type={'checkbox'} id={label} name={label} onChange={onChange} checked={value} disabled={disabled} /> <Label htmlFor={label}>{label}{required && <span style={{color: 'red', marginLeft: '2px'}}>*</span>}</Label>
    </CheckboxContainer>
);

export default Checkbox;